<template>
  <div class="mc-page">

    <!-- ===================================================== -->
    <!-- INTRO STRIP                                           -->
    <!-- ===================================================== -->
    <!-- <div class="mc-intro">
      <div class="mc-intro-text">
        <div class="mc-intro-label">Modules</div>
        <div class="mc-intro-title">
          Browse all modules
          <span v-if="visibleModulesCount > 0" class="mc-count-pill">{{ visibleModulesCount }}</span>
        </div>
      </div>
      <div class="mc-intro-tags">
        <span class="mc-tag is-orange">
          <b-icon icon="grid-3x3-gap-fill"></b-icon> {{ visibleModulesCount }} available
        </span>
      </div>
    </div> -->

    <!-- ===================================================== -->
    <!-- MODULES GRID                                          -->
    <!-- ===================================================== -->
    <div class="modules-grid">

      <!-- SALES -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','accountmanager','officeuser','officemanager','locationadmin','salesperson','accountuser'])"
           @click="$router.push('/sales/main/')">
        <div class="card-accent is-sales"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="graph-up"></b-icon>
          </div>
          <div class="card-info">
            <h3>SALES</h3>
            <p>Sales management and tracking</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- PROCESS SALES -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','accountmanager','officeuser','officemanager','salesperson','accountuser'])"
           @click="$router.push('/admin_tools/main/')">
        <div class="card-accent is-process"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="gear-wide-connected"></b-icon>
          </div>
          <div class="card-info">
            <h3>PROCESS SALES</h3>
            <p>System administration and tools</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- PROCESS DELIVERIES -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','accountmanager','officeuser','officemanager','locationstockperson','salesperson','warehouseuser','warehousemanager','housetruck','deliverytruck'])"
           @click="$router.push('/incoming_outgoing/main/')">
        <div class="card-accent is-shipping"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="truck"></b-icon>
          </div>
          <div class="card-info">
            <h3>PROCESS DELIVERIES</h3>
            <p>Manage incoming and outgoing shipments</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- RECEIVING -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','officeuser','officemanager','locationadmin','locationstockperson','warehouseuser','warehousemanager'])"
           @click="$router.push('/receiving/main/')">
        <div class="card-accent is-receiving"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="inbox"></b-icon>
          </div>
          <div class="card-info">
            <h3>RECEIVING</h3>
            <p>Receiving logs and inventory movement</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- SHIPPING -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','warehousemanager','warehouseuser','deliverytruck','locationadmin'])"
           @click="$router.push('/shipping/main/')">
        <div class="card-accent is-shipping-blue"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="box-seam"></b-icon>
          </div>
          <div class="card-info">
            <h3>SHIPPING</h3>
            <p>Shipping management and tracking</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- STORE STOCK TRANSFER -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','officemanager','locationadmin','housetruck','warehousemanager'])"
           @click="$router.push('/transfer_orders/main/')">
        <div class="card-accent is-transfer"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="arrow-left-right"></b-icon>
          </div>
          <div class="card-info">
            <h3>STORE STOCK TRANSFER</h3>
            <p>Inventory transfer between locations</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- VENDOR ORDERS -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','accountmanager','officeuser','officemanager','locationadmin','locationstockperson','salesperson','warehouseuser','warehousemanager','accountuser'])"
           @click="$router.push('/vendor_orders/main/')">
        <div class="card-accent is-vendor"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="journal-check"></b-icon>
          </div>
          <div class="card-info">
            <h3>VENDOR ORDERS</h3>
            <p>Vendor and purchase order management</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- PRODUCTS -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','accountmanager','officeuser','officemanager','locationadmin','locationstockperson','accountuser'])"
           @click="$router.push('/products/main/')">
        <div class="card-accent is-products"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="box"></b-icon>
          </div>
          <div class="card-info">
            <h3>PRODUCTS</h3>
            <p>Product catalog and info management</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- INVENTORY -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','officeuser','officemanager','locationadmin','locationstockperson','salesperson','warehouseuser','warehousemanager','accountuser'])"
           @click="$router.push('/inventory/main/')">
        <div class="card-accent is-inventory"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="archive-fill"></b-icon>
          </div>
          <div class="card-info">
            <h3>INVENTORY</h3>
            <p>Inventory management and stock control</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- SALES REPORTS -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','officeuser','officemanager','locationadmin','locationstockperson','salesperson','warehouseuser','warehousemanager','accountuser'])"
           @click="$router.push('/reports/main/')">
        <div class="card-accent is-reports"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="pie-chart-fill"></b-icon>
          </div>
          <div class="card-info">
            <h3>SALES REPORTS</h3>
            <p>Business intelligence and reporting</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- PRODUCT PERFORMANCE -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','officeuser','officemanager','locationadmin','locationstockperson','salesperson','warehouseuser','warehousemanager','accountuser'])"
           @click="$router.push('/product-reports/main/')">
        <div class="card-accent is-performance"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="bar-chart-fill"></b-icon>
          </div>
          <div class="card-info">
            <h3>PRODUCT PERFORMANCE</h3>
            <p>Product analytics and performance metrics</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- CUSTOMER SERVICE -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','officeuser','officemanager','locationadmin','locationstockperson','salesperson','warehouseuser','warehousemanager','accountuser'])"
           @click="$router.push('/customer_service/main/')">
        <div class="card-accent is-customer"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="headset"></b-icon>
          </div>
          <div class="card-info">
            <h3>CUSTOMER SERVICE</h3>
            <p>Customer support and service management</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- DELIVERIES & TRIPS -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','officeuser','officemanager','locationadmin','locationstockperson','salesperson','warehouseuser','warehousemanager','accountuser'])"
           @click="$router.push('/DeliveryCalendar/main/')">
        <div class="card-accent is-delivery"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="calendar-week"></b-icon>
          </div>
          <div class="card-info">
            <h3>DELIVERIES &amp; TRIPS</h3>
            <p>Delivery calendar and delivery management</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- CUSTOMERS -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','accountmanager','officeuser','officemanager','locationadmin','salesperson','accountuser'])"
           @click="$router.push('/customers/main/')">
        <div class="card-accent is-customers"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="people-fill"></b-icon>
          </div>
          <div class="card-info">
            <h3>CUSTOMERS</h3>
            <p>Customer information and order management</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="arrow-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- ADMIN TOOLS -->
      <div class="module-card modern-card"
           v-if="showModule(['admin','officeuser','officemanager','locationadmin','locationstockperson','salesperson','warehouseuser','warehousemanager','accountuser'])"
           @click="showAdminToolsModal = true">
        <div class="card-accent is-admin"></div>
        <div class="card-body">
          <div class="card-icon-wrapper">
            <b-icon icon="sliders"></b-icon>
          </div>
          <div class="card-info">
            <h3>ADMIN TOOLS</h3>
            <p>System configuration and user management</p>
          </div>
          <div class="card-action-btn">
            <b-icon icon="box-arrow-up-right"></b-icon>
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div class="empty-modules" v-if="visibleModulesCount === 0">
        <div class="empty-icon"><b-icon icon="inbox" font-scale="2.4"></b-icon></div>
        <h3>No modules available</h3>
        <p>There are no modules for your role.</p>
      </div>
    </div>

    <!-- ===================================================== -->
    <!-- ADMIN TOOLS MODAL                                     -->
    <!-- ===================================================== -->
    <b-modal v-model="showAdminToolsModal" size="md" hide-footer centered content-class="mc-modal">
      <template #modal-header>
        <div class="mc-modal-title">
          <span class="mc-modal-title-icon"><b-icon icon="sliders"></b-icon></span>
          <div>
            <div class="mc-modal-title-main">Admin tools</div>
            <div class="mc-modal-title-sub">System configuration</div>
          </div>
        </div>
      </template>

      <div class="mc-modal-body">
        <ul class="tool-list">

          <li class="tool-card" v-if="showModule(['admin'])" @click="navigateTo('/locations/main/')">
            <span class="tool-icon is-locations"><b-icon icon="geo-alt-fill"></b-icon></span>
            <div class="tool-info">
              <div class="tool-title">Locations</div>
              <div class="tool-sub">Location and branch management</div>
            </div>
            <b-icon icon="chevron-right" class="tool-arrow"></b-icon>
          </li>

          <li class="tool-card" v-if="showModule(['admin'])" @click="navigateTo('/control_panel/main/')">
            <span class="tool-icon is-control"><b-icon icon="sliders"></b-icon></span>
            <div class="tool-info">
              <div class="tool-title">Control panel</div>
              <div class="tool-sub">System configuration and settings</div>
            </div>
            <b-icon icon="chevron-right" class="tool-arrow"></b-icon>
          </li>

          <li class="tool-card" v-if="showModule(['admin'])" @click="navigateTo('/users/main/')">
            <span class="tool-icon is-users"><b-icon icon="person-badge-fill"></b-icon></span>
            <div class="tool-info">
              <div class="tool-title">Users</div>
              <div class="tool-sub">User account and permission management</div>
            </div>
            <b-icon icon="chevron-right" class="tool-arrow"></b-icon>
          </li>
          <li class="tool-card" v-if="showModule(['admin'])" @click="navigateTo('/accounting/main/')">
            <span class="tool-icon is-accounting" style="background: linear-gradient(135deg, #EE7A22, #F5CFAE);">
              <b-icon icon="calculator"></b-icon>
            </span>
            <div class="tool-info">
              <div class="tool-title">Accounting &amp; Management</div>
              <div class="tool-sub">Invoices, payments, and ledgers</div>
            </div>
            <b-icon icon="chevron-right" class="tool-arrow"></b-icon>
          </li>

        </ul>

        <div class="mc-modal-foot">
          <b-button class="mc-btn-ghost" @click="showAdminToolsModal = false">Close</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ModuleCards",
  props: {
    userDetails: { type: Object, default: () => ({}) },
    searchQuery: { type: String, default: "" }
  },
  data() {
    return {
      showAdminToolsModal: false,
      localSearchQuery: ""
    };
  },
  watch: {
    searchQuery: { immediate: true, handler(val) { this.localSearchQuery = val; } },
    localSearchQuery(val) { this.$emit("update:searchQuery", val); }
  },
  computed: {
    modules() {
      return [
        { search: "SALES" },
        { search: "PROCESS SALES" },
        { search: "PROCESS DELIVERIES" },
        { search: "RECEIVING" },
        { search: "SHIPPING" },
        { search: "STORE STOCK TRANSFER" },
        { search: "VENDOR ORDERS" },
        { search: "PRODUCTS" },
        { search: "INVENTORY" },
        { search: "REPORTS" },
        { search: "PRODUCT PERFORMANCE" },
        { search: "CUSTOMER SERVICE" },
        { search: "DELIVERIES & TRIPS" },
        { search: "CUSTOMERS" },
        { search: "ADMIN TOOLS" }
      ];
    },
    visibleModulesCount() {
      return this.modules.filter((m) => this.matchesSearch(m.search)).length;
    }
  },
  methods: {
    showModule(roles) { return roles.includes(this.userDetails.userrole); },
    matchesSearch(name) {
      if (!this.localSearchQuery) return true;
      return name.toLowerCase().includes(this.localSearchQuery.toLowerCase());
    },
    clearSearch() { this.localSearchQuery = ""; },
    navigateTo(route) {
      this.showAdminToolsModal = false;
      this.$router.push(route);
    }
  }
};
</script>

<style scoped>
/* ===================================================== */
/* PAGE SHELL                                            */
/* ===================================================== */
.mc-page {
  font-family: 'Manrope', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  color: #221F1C;
  font-size: 17px;
}

/* ===================================================== */
/* INTRO STRIP                                           */
/* ===================================================== */
.mc-intro {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  background: #fff;
  border: 1px solid #E5E1DA;
  border-radius: 16px;
  padding: 14px 18px;
  margin-bottom: 14px;
}
.mc-intro-label {
  font-size: 12px;
  font-weight: 700;
  color: #736C63;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.mc-intro-title {
  font-family: 'Sora', sans-serif;
  font-size: 22px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 2px;
}
.mc-count-pill {
  display: inline-flex; align-items: center; justify-content: center;
  background: #EE7A22; color: #fff;
  font-family: 'Sora', sans-serif;
  font-size: 13px; font-weight: 800;
  padding: 3px 12px; border-radius: 999px;
}
.mc-intro-tags { display: flex; gap: 8px; flex-wrap: wrap; }
.mc-tag {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 13px; font-weight: 700;
  padding: 5px 13px; border-radius: 999px;
  background: #FFF1E4; color: #D4620F;
  border: 1px solid #F5CFAE;
}

/* ===================================================== */
/* GRID                                                  */
/* ===================================================== */
.modules-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
}

/* ===================================================== */
/* CARD                                                  */
/* ===================================================== */
.modern-card {
  position: relative;
  background: #fff;
  border: 1px solid #E5E1DA;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}
.modern-card:hover {
  transform: translateY(-3px);
  border-color: #EE7A22;
  box-shadow: 0 16px 32px -18px rgba(34, 31, 28, 0.35);
}

.card-accent {
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 5px;
}
.card-accent.is-sales          { background: linear-gradient(90deg, #0F6E6B, #3FB6A8); }
.card-accent.is-process        { background: linear-gradient(90deg, #C98A12, #E0A524); }
.card-accent.is-shipping       { background: linear-gradient(90deg, #C93C30, #E0736A); }
.card-accent.is-shipping-blue  { background: linear-gradient(90deg, #2B83B5, #5FA8D3); }
.card-accent.is-receiving      { background: linear-gradient(90deg, #5E37A3, #8B6ACF); }
.card-accent.is-transfer       { background: linear-gradient(90deg, #D6588A, #F088B0); }
.card-accent.is-vendor         { background: linear-gradient(90deg, #0F6E6B, #2DD4BF); }
.card-accent.is-products       { background: linear-gradient(90deg, #D4620F, #EE7A22); }
.card-accent.is-inventory      { background: linear-gradient(90deg, #2B83B5, #22C3E6); }
.card-accent.is-reports        { background: linear-gradient(90deg, #5E37A3, #8B6ACF); }
.card-accent.is-performance    { background: linear-gradient(90deg, #D4620F, #EE7A22); }
.card-accent.is-customer       { background: linear-gradient(90deg, #D6588A, #F088B0); }
.card-accent.is-delivery       { background: linear-gradient(90deg, #4F8A1F, #8ABF4D); }
.card-accent.is-customers      { background: linear-gradient(90deg, #2B83B5, #5FA8D3); }
.card-accent.is-admin          { background: linear-gradient(90deg, #4A4540, #736C63); }

.card-body {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 18px 18px;
}
.card-icon-wrapper {
  width: 52px; height: 52px;
  border-radius: 14px;
  background: #F7F5F2;
  border: 1px solid #E5E1DA;
  display: flex; align-items: center; justify-content: center;
  font-size: 22px;
  color: #EE7A22;
  flex-shrink: 0;
  transition: all 0.2s ease;
}
.modern-card:hover .card-icon-wrapper {
  background: #EE7A22;
  color: #fff;
  border-color: #EE7A22;
}

.card-info { flex: 1; min-width: 0; }
.card-info h3 {
  font-family: 'Sora', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #221F1C;
  margin: 0 0 4px;
  letter-spacing: 0.02em;
}
.card-info p {
  font-size: 13.5px;
  color: #736C63;
  margin: 0;
  line-height: 1.45;
}

.card-action-btn {
  width: 36px; height: 36px;
  border-radius: 10px;
  background: #F7F5F2;
  border: 1px solid #E5E1DA;
  display: flex; align-items: center; justify-content: center;
  color: #4A4540;
  flex-shrink: 0;
  transition: all 0.2s ease;
  font-size: 16px;
}
.modern-card:hover .card-action-btn {
  background: #221F1C;
  color: #fff;
  border-color: #221F1C;
  transform: translateX(3px);
}

/* ===================================================== */
/* EMPTY STATE                                           */
/* ===================================================== */
.empty-modules {
  grid-column: 1 / -1;
  text-align: center;
  padding: 60px 30px;
  background: #FAF9F7;
  border: 2px dashed #D6CFC4;
  border-radius: 16px;
}
.empty-icon {
  width: 78px; height: 78px;
  border-radius: 22px;
  background: #FFF1E4; color: #EE7A22;
  display: inline-flex; align-items: center; justify-content: center;
  margin-bottom: 16px;
  font-size: 34px;
}
.empty-modules h3 {
  font-family: 'Sora', sans-serif;
  font-size: 22px; font-weight: 700;
  margin: 0 0 8px;
}
.empty-modules p {
  color: #736C63; font-size: 16px;
  margin: 0; max-width: 50ch;
  margin-left: auto; margin-right: auto;
}

/* ===================================================== */
/* MODAL                                                 */
/* ===================================================== */
.mc-modal.modal-content {
  border: 0; border-radius: 20px; overflow: hidden;
  box-shadow: 0 30px 70px -20px rgba(34, 31, 28, 0.5);
}
.mc-modal .modal-header {
  background: #221F1C !important;
  color: #fff !important;
  border: 0 !important;
  border-bottom: 4px solid #EE7A22 !important;
  padding: 16px 22px !important;
}
.mc-modal .modal-header .close { color: #fff !important; opacity: 0.85; text-shadow: none; }
.mc-modal .modal-body { background: #F6F4F0; padding: 20px 22px; }

.mc-modal-title { display: flex; align-items: center; gap: 14px; }
.mc-modal-title-icon {
  width: 42px; height: 42px; border-radius: 12px;
  background: rgba(238, 122, 34, 0.2);
  color: #FFB06B;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 18px;
}
.mc-modal-title-main { font-family: 'Sora', sans-serif; font-size: 19px; font-weight: 700; }
.mc-modal-title-sub { font-size: 13px; color: rgba(255, 255, 255, 0.65); }

.mc-modal-body { display: flex; flex-direction: column; gap: 14px; }

.tool-list {
  list-style: none; margin: 0; padding: 0;
  display: flex; flex-direction: column; gap: 10px;
}
.tool-card {
  display: flex; align-items: center; gap: 14px;
  background: #fff;
  border: 1px solid #E5E1DA;
  border-radius: 12px;
  padding: 14px 16px;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.tool-card:hover {
  border-color: #EE7A22;
  box-shadow: 0 6px 16px -10px rgba(34, 31, 28, 0.25);
}
.tool-icon {
  width: 44px; height: 44px; border-radius: 12px;
  display: inline-flex; align-items: center; justify-content: center;
  color: #fff; font-size: 20px; flex-shrink: 0;
}
.tool-icon.is-locations { background: linear-gradient(135deg, #2B83B5, #5FA8D3); }
.tool-icon.is-control   { background: linear-gradient(135deg, #4A4540, #736C63); }
.tool-icon.is-users     { background: linear-gradient(135deg, #0F6E6B, #3FB6A8); }

.tool-info { flex: 1; min-width: 0; }
.tool-title {
  font-family: 'Sora', sans-serif;
  font-size: 15px; font-weight: 700; color: #221F1C;
}
.tool-sub { font-size: 13px; color: #736C63; margin-top: 2px; }
.tool-arrow { color: #A59D92; font-size: 16px; }
.tool-card:hover .tool-arrow { color: #EE7A22; transform: translateX(3px); }

.mc-modal-foot {
  padding-top: 12px;
  border-top: 1px solid #E5E1DA;
  text-align: right;
}
.mc-btn-ghost.btn {
  background: #fff !important;
  color: #221F1C !important;
  border: 1.5px solid #E5E1DA !important;
  border-radius: 10px !important;
  font-weight: 700;
  font-size: 14.5px;
  padding: 8px 18px;
}
.mc-btn-ghost.btn:hover { border-color: #EE7A22 !important; color: #D4620F !important; }

/* ===================================================== */
/* RESPONSIVE                                            */
/* ===================================================== */
@media (max-width: 767px) {
  .modules-grid { grid-template-columns: 1fr; gap: 12px; }
  .card-body { padding: 16px 14px 14px; }
  .card-icon-wrapper { width: 44px; height: 44px; font-size: 19px; }
  .card-info h3 { font-size: 14px; }
  .card-info p { font-size: 12.5px; }
}
</style>


// WEBPACK FOOTER //
// src/components/Homepagecomponents/ModuleCards.vue